import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import * as saveAs from 'file-saver';
import { MatSelectChange } from '@angular/material/select';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IIncidents } from 'src/app/models/incident';
import { UserRegDetails } from 'src/app/models/user';
import { Visitor } from 'src/app/models/visitor';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { IAssets } from 'src/app/models/assets';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AttendandeObject, IEmployee } from 'src/app/models/IEmployee';
import { PrintableActivityDialogComponent } from '../printable-activity-dialog/printable-activity-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { ColDef, GridOptions, GridReadyEvent } from 'ag-grid-community';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as ExcelJS from 'exceljs';
import { Store } from '@ngrx/store';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
// import { IReportsState } from 'src/app/state-management/states/aumye-reports.state';
import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import { CreateIncident } from 'src/app/models/incident';
import { Observable, take } from 'rxjs';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
import { environment } from 'src/app/environments/environments';
import {
  EncryptionService,
  UserDetailsToken,
} from 'src/app/services/Encryption/encryption.service';
// Set pdfMake's virtual file system
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-reports-page-data',
  templateUrl: './reports-page-data.component.html',
  styleUrls: ['./reports-page-data.component.scss'],
})
export class ReportsPageDataComponent implements OnInit {
  @Output() sendReportsToEmail = new EventEmitter<any>();
  @Output() onSearchNumberAnpr = new EventEmitter<any>();
  searchQuery: any;
  filteredUsers: UserRegDetails[];
  filteredAssets: IAssets[];
  isANPR: boolean;
  isFace = false;
  disabledOrgIds: string[];
  isDisableFeature: boolean;

  @Input() set userList(val: UserRegDetails[]) {
    this.filteredEmployeeDataSource = val.filter((x) => x.isEmployee == 'true');
  }
  @Input() numberFound: {
    numberPlate: string;
    incidentId: string;
    matchScore: number;
  };
  @Input() isError: boolean = false;
  @Input() isNumberFound: boolean = false;
  @Input() assets: IAssets[];

  @Input() set visitor(val: Visitor[]) {
    this.visitorList = val;
    this.filteredVisitor = this.visitorList;
    this.filteredVisitorDataSource = val;
    this.preApprovedList = val.filter((x) => x.isPreApproved === 'true');
    this.verifiedVisitor = val.filter((x) => x.securityStatus == 1);
    this.unVerifiedVisitor = val.filter((x) => x.securityStatus == 0);
  }
  @Input() set incident(val: IIncidents[]) {
    this.incidentList = val;
    this.filteredIncident = this.incidentList;
    this.anprList = this.incidentList.filter((x) => x.isANPR == 1);
    this.faceList = this.incidentList.filter((x) => x.isFaceMatch == 1);
    this.fireList = this.incidentList.filter((x) => x.incidentName === 'Fire');
    this.intrusionList = this.incidentList.filter(
      (x) => x.incidentName === 'Intrusion'
    );
    this.temp = val;
    this.filtered = val;
    this.filteredDataSource = this.incidentList;
  }
  @ViewChild('SubmittingRequestDialog', { static: true })
  submittingRequestDialog: TemplateRef<any>;
  isShowDetails = false;
  isIncident = false;
  isVisitor = false;
  isEmployee = false;
  expandedDetail = '';
  filteredDataSource: IIncidents[] = [];
  filteredVisitorDataSource: Visitor[] = [];
  filteredEmployeeDataSource: UserRegDetails[] = [];
  customFilteredVisitorDataSource: Visitor[] = [];
  customFilteredIncidentDataSource: IIncidents[] = [];
  EmployeeDataSource: IEmployee[] = [];
  dataSource: AttendandeObject;
  private gridApi: any;
  gridOptions: GridOptions;
  fileName: string;
  baseServerURL = environment.apiUrl;
  orgId: string = null;
  orgName: string = null;
  // Extracting date and time components
  optionsDate: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };
  optionsTime: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };
  tableData: any[] = [];

  headers = [
    'No',
    'Incident Name',
    'Description',
    'Type',
    'Date',
    'Time',
    'Device',
    'Assignee',
  ];

  public columnDefs: ColDef[] = this.headers.map((header) => ({
    headerName: header,
    field: header.replaceAll(' ', ''),
    // maxWidth: header === 'No' ? 55 : 135,
    autoHeight: true,
    editable: false,
  }));

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 75,
    // editable: true,
    resizable: true,
    autoHeight: true,
  };

  incidentTypes = [
    // 'All',
    'Abandoned Object',
    'ANPR',
    'ANPR Unverified',
    'ANPR Verified',
    'Automatic',
    'Claims',
    'Communication Failure',
    'Crowd',
    'Custom Incident',
    'Device Faulty',
    'Device Offline',
    'Electricity Incident',
    'Employee',
    'Face Recognition Activity',
    'Face Unverified',
    'Face Verified',
    'Fire Unverified',
    'Fire Verified',
    'General Activity',
    'Housekeeping',
    'Incident',
    'Infrastructure Damage',
    'Intrusion',
    'Link Activity',
    'Loss/Damage of Property',
    'Manual',
    'Over Utilised Energy',
    'Plumbing Incident',
    'Possible Crime',
    'Pre-Approved Visitor',
    'Riot/Protest',
    'Suspicious Behaviour',
    'Theft/Pilferage',
    'Unattended Incident',
    'UncheckedOut Visitor',
    'Unattended SoS',
    'Unidentified Person',
    'Unmonitored Asset',
    'Unmonitored logs/activity',
    'Under Utilised Energy',
    'Unsettled Claims',
    'Unverified Vehicle',
    'Unverified Visitor',
    'Unauthorised/Intruded Entry',
    'Verified Visitor',
    'Visitor',
  ];

  maxDate = new Date();
  temp: IIncidents[] = [];
  filtered: IIncidents[] = [];
  filteredd: Visitor[] = [];
  customFilteredd: Visitor[] = [];
  customIncidentFilteredd: IIncidents[] = [];
  isChecked = false;
  isReportGenerated = false;
  anprList: IIncidents[];
  faceList: IIncidents[];
  fireList: IIncidents[];
  intrusionList: IIncidents[];
  incidentList: IIncidents[];
  verifiedVisitor: Visitor[];
  unVerifiedVisitor: Visitor[];
  preApprovedList: Visitor[];
  visitorList: Visitor[];
  screenSize: ScreenType;
  recipientsControl = new FormControl();
  hostFilter = new FormControl();
  visitorFilter = new FormControl();
  incidentFilter = new FormControl();
  anprFilter = new FormControl();
  faceRecognizationFilter = new FormControl();
  intrusionFilter = new FormControl();
  fireFilter = new FormControl();
  filteredHosts: UserRegDetails[] = [];
  filteredVisitor: Visitor[] = [];
  filteredIncident: IIncidents[] = [];
  filteredFire: IIncidents[] = [];
  filteredFace: IIncidents[] = [];
  filteredIntrusion: IIncidents[] = [];
  filteredAnpr: IIncidents[] = [];
  selectedAssetId: string = null;
  eventEvidence: any = null;
  filteredIncidentTypes: string[] = [];
  selectedUsers: UserRegDetails[] = [];

  @Output() onSubmitRequest = new EventEmitter();
  @Output() showReportsDetail = new EventEmitter();
  reportDataState$: Observable<IDashboardState>;
  loggedUser: UserDetailsToken;

  constructor(
    private store: Store<IAumyeState>,
    private screen: AumyeResponsiveScreenService,
    private _formbuilder: FormBuilder,
    private dialog: MatDialog,
    private _http: HttpClient,
    private toastr: ToastrService,
    private encryptionService: EncryptionService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }

  reportData = this._formbuilder.group({
    module: ['', [Validators.required]],
    startDate: [null, [Validators.required]],
    endDate: [null, [Validators.required]],
    source: [],
    vehicleNumber: [
      '',
      // [Validators.pattern('^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$')],
    ],
    visitorSearch: [],
    // assignedRecieversId: [],
  });

  ngOnInit(): void {
    this.loggedUser = this.encryptionService.getCurrentUser();
    this.orgId = this.loggedUser.organizationID;
    this.orgName = this.loggedUser.organizationName;
    this.disabledOrgIds = environment.printerAllowed;
    this.isDisableFeature = this.disabledOrgIds
      .map((id) => id.toLowerCase())
      .includes(this.orgId);
    this.filteredHosts = this.userList;
    this.filteredAssets = this.assets;
    this.filteredIncidentTypes = this.incidentTypes;
    this.filteredUsers = this.getFilteredUsers();
    this.recipientsControl.valueChanges.subscribe((value) =>
      this.filterUsers(value)
    );
  }
  getFilteredUsers(): UserRegDetails[] {
    return this.filteredEmployeeDataSource.filter(
      (x) => x.userRole === 'admin' || x.userRole === 'supervisor'
    );
  }
  filterAssets(event: any) {
    const query = (event.target as HTMLInputElement).value.toLowerCase(); // Type-casting the event.target to HTMLInputElement
    this.filteredAssets = this.assets.filter(
      (asset) => asset.assetName.toLowerCase().includes(query) // Filter assets by asset name
    );
  }
  filterSource(event: any) {
    const query = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredIncidentTypes = this.incidentTypes.filter((incidentType) =>
      incidentType.toLowerCase().includes(query.toLowerCase())
    );
  }
  filterUsers(event: any = ''): void {
    // const filterValue = (event as string).trim();
    // const filterValue = (event.target ? (event.target.value as string) : event).trim().toLowerCase();
    // Check if the event has a target and if the target has a value property
    let filterValue = '';
    if (event && event.target && typeof event.target.value === 'string') {
      filterValue = event.target.value.trim().toLowerCase(); // Get the trimmed string
    } else if (typeof event === 'string') {
      filterValue = event.trim().toLowerCase(); // In case a direct string is passed instead of an event
    }
    this.filteredUsers = this.getFilteredUsers();
    // if (filterValue !== '') {
    this.filteredUsers = this.filteredUsers.filter(
      (user) =>
        (user.firstname + ' ' + user.lastname)
          .toLowerCase()
          .includes(filterValue) && !this.selectedUsers.includes(user)
    );
    // }
  }

  removeReceiver(user: any): void {
    const index = this.selectedUsers.indexOf(user);
    if (index >= 0) {
      this.selectedUsers.splice(index, 1);
    }
  }
  onSelectReceiver(event: any): void {
    const selectedUser = event.option.value;
    if (!this.selectedUsers.includes(selectedUser)) {
      this.selectedUsers.push(selectedUser);
    }
    this.filterUsers();
    this.recipientsControl.setValue(' ');
  }
  statusMap: any = {
    0: 'Open',
    1: 'Close',
    2: 'Verified',
    3: 'Snoozed',
    4: 'In-Progress',
    5: 'On-Hold',
    6: 'Approved',
    7: 'Rejected',
  };
  // const incidentStatus: any = val.incidentStatus;
  getStatusData(val: number) {
    const statusMap: any = {
      '-1': 'Rejected',
      '0': 'Unverified',
      '1': 'Verified',
      '3': 'AutoRejected',
      '4': 'InProgress',
      '5': 'Complete',
      '6': 'CheckedIn',
      '7': 'CheckedOut',
      '8': 'Created',
      '9': 'Deleted',
      '10': 'Unknown',
      '11': 'ManuallyVerified',
    };
    return statusMap[val.toString()] || 'Unknown';
  }
  onChooseModule(event: any) {
    const selectedValue = event.option.value;
    this.isIncident = false;
    this.isVisitor = false;
    this.isEmployee = false;
    this.isANPR = false;
    this.isReportGenerated = false;
    if (selectedValue === 'Employee') {
      this.isEmployee = true;
    } else if (
      selectedValue === 'Visitor' ||
      selectedValue === 'Pre-Approved Visitor' ||
      selectedValue === 'Verified Visitor' ||
      selectedValue === 'Unverified Visitor' ||
      selectedValue === 'Face Recognition'
    ) {
      this.isVisitor = true;
    } else if (
      selectedValue === 'ANPR' ||
      selectedValue === 'ANPR Unverified' ||
      selectedValue === 'ANPR Verified'
    ) {
      this.isANPR = true;
      this.isIncident = true;
    } else {
      this.isIncident = true;
    }
    this.isFace = false;
    if (
      selectedValue === 'Employee' ||
      selectedValue === 'Face Recognition Activity' ||
      selectedValue === 'Face Unverified' ||
      selectedValue === 'Face Verified' ||
      selectedValue === 'All'
    ) {
      this.isFace = true;
    }
  }
  onUploadFace(event: any) {
    if (event.target.files[0]) {
      // this.reportData.controls['assignedRecieversId'].setValidators([
      //   Validators.required,
      // ]);

      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.eventEvidence = event.target.result;
      };
    } /* else {
      this.reportData.controls['assignedRecieversId'].clearValidators();
    }
    this.reportData.controls['assignedRecieversId'].updateValueAndValidity(); */
  }

  // Resizing columns based on grid width
  private resizeColumnsToFit(gridApi: any): void {
    gridApi.sizeColumnsToFit();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.resizeColumnsToFit(params.api);
  }

  onDataRendered(params: GridReadyEvent) { }
  getRowHeight(params: any) {
    return params.data.description ? 100 : 50;
  }
  getMaxWidth() {
    // Calculate max width based on screen size
    const screenWidth = window.innerWidth;
    return Math.floor(screenWidth / 8); // Example: 1/6th of screen width
  }
  onCellValueChanged(event: any) {
    // This function is called when a cell value is changed
    // console.log('Cell value changed:', event);
    // You can perform any additional actions here, such as updating the underlying data
  }

  onRowValueChanged(event: any) {
    // This function is called when a row value is changed
    // console.log('Row value changed:', event);
    // You can perform any additional actions here, such as updating the underlying data
  }
  searchText: string = '';
  onSearch() {
    const filterText = this.searchText.toLowerCase();
    // this.gridApi.setQuickFilter(filterText);
    this.gridApi.setQuickFilter(filterText);
  }

  private numberToAlphabet(num: number): string {
    let result = '';

    while (num > 0) {
      num--;
      result = String.fromCharCode((num % 26) + 65) + result;
      num = Math.floor(num / 26);
    }

    return result;
  }
  exportToCsv() {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(`${this.fileName.split('_')[0]}`);

    // Set the page layout to A4 landscape
    worksheet.pageSetup.orientation = 'landscape'; // Landscape orientation
    worksheet.pageSetup.paperSize = 9; // Paper size 9 corresponds to A4

    // Add title rows
    const titleRow1 = worksheet.addRow([
      `${this.fileName.split('_')[0]} ( ${this.fileName.split('_')[1]} - ${this.fileName.split('_')[2]
      } - ${this.fileName.split('_')[3]} )`,
    ]);
    worksheet.mergeCells(`A1:${this.numberToAlphabet(this.headers.length)}1`);
    titleRow1.getCell(1).alignment = { horizontal: 'center' };
    titleRow1.getCell(1).font = { bold: true, size: 14 };

    const titleRow2 = worksheet.addRow([
      `(Generated By: Aumye | Requested By: ${this.loggedUser.fullName})`,
    ]);
    worksheet.mergeCells(`A2:${this.numberToAlphabet(this.headers.length)}2`);
    titleRow2.getCell(1).alignment = { horizontal: 'center' };
    titleRow2.getCell(1).font = { size: 12 };

    // Add main headers
    const headers = this.headers.map((header) => header.toUpperCase());
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true, size: 10 }; // Adjust header font size
    worksheet.getRow(3).height = 18; // Adjust height of header row

    // Populate data rows
    this.tableData.forEach((data: { [x: string]: any }, index) => {
      const row = this.headers.map(
        (header) => data[header.replaceAll(' ', '')]
      );
      const dataRow = worksheet.addRow(row);
      dataRow.font = { size: 9 }; // Adjust font size for data rows
      worksheet.getRow(index + 4).height = 16; // Adjust height for each data row starting from row 4
    });

    // Save the workbook and create the Excel file Blob
    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${this.fileName}.xlsx`;
        link.click();

        // Convert Blob to Base64
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result as string;
          this.createService(base64data, 'xlsx');
        };

        reader.readAsDataURL(blob); // Read the Blob as Base64
      })
      .catch((error) => {
        console.error('Error generating Excel file:', error);
      });
  }

  createService(base64data: string, type: string) {
    // Prepare data for complaint
    const date = new Date().toISOString();
    const data = {
      assignedAdminId: localStorage.getItem('AumyeId'),
      assignedAdminName: localStorage.getItem('Aumye'),
      claimAmount: '',
      claimType: '',
      leaveType: '1',
      complainDescription: 'Report Request',
      complainSubject: 'Service Request',
      startDate: date,
      singleDate: date,
      endDate: date,
      incidentCriticality: 'Low',
      attachments: [
        {
          attachedContent: base64data, // Add the Base64 string as the attachment
          attachedContentName: `${this.fileName}${type === 'xlsx' ? '.xlsx' : '.pdf'
            }`,
          attachedContentType:
            type === 'xlsx'
              ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              : 'application/pdf',
          selectedAttachment: {},
        },
      ],
    };

    // Dispatch the action with the complaint data
    this.store.dispatch(new fromDashboardActions.LodgeUserComplain(data));

    this.reportDataState$ = this.store.select('aumyeDashboardState');
    this.reportDataState$.pipe(take(1)).subscribe((data) => { });
  }

  createTableForIncident(parsedResponse: IIncidents[]) {
    const module = this.reportData.get('module')!.value;
    const optionsDate: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    };
    this.headers = [
      'No',
      'Incident ID',
      'Incident Name',
      'Description',
      'Type',
      'Date',
      'Time',
      'Device',
      'Status',
      'Reporter',
      'Assignee',
    ];
    this.isANPR ? this.headers.push('Owner') : '';
    this.columnDefs = this.headers.map((header) => ({
      headerName: header,
      field: header.replaceAll(' ', ''),
      maxWidth: 300,
      minWidth: 100,
      autoHeight: true,
      editable: false,
      resizable: true,
      sortable: true,
      filter: true,
      cellClass: 'word-wrap',
      flex: header === 'Description' ? 2 : 1,
      cellStyle: { whiteSpace: 'normal' },
    }));

    this.customFilteredIncidentDataSource = parsedResponse;
    this.customIncidentFilteredd = parsedResponse;
    this.isReportGenerated = true;
    this.tableData = parsedResponse.flatMap((header, headerIndex) => {
      if (Array.isArray(header.incidentGraph)) {
        // Sort the incidentGraph by index if needed
        // header.incidentGraph.sort((a, b) => a.index - b.index);
        header.incidentGraph.sort(
          (a, b) =>
            new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime()
        );

        // Map to the desired structure
        return header.incidentGraph.map((data, dataIndex) => {
          const rowData: any = {
            No: `${headerIndex + 1}.${dataIndex + 1}`,
            IncidentID: header.incidentId,
            IncidentName: header.incidentName,
            Description: header.incidentDescription,
            Reporter: header.eventCreatedBy,
            Type: header.incidentType,
            Status: this.statusMap.hasOwnProperty(data.status)
              ? this.statusMap[data.status]
              : 'Not Specified',
            // Date: new Intl.DateTimeFormat('en-US', this.optionsDate).format(
            //   new Date(data.eventDate)
            // ),
            Date: new Intl.DateTimeFormat('en-GB', optionsDate).format(new Date(data.eventDate)),
            Time: new Intl.DateTimeFormat('en-US', this.optionsTime).format(
              new Date(data.eventDate)
            ),
            Device: header.sourceAsset,
            Assignee: header.assignedTo,
          };

          if (this.isANPR) {
            rowData['Owner'] = header.associateName || 'Not Specified'; // Assuming owner is available in the header
          }

          return rowData;
        });
      } else {
        console.warn(
          `No valid visitorTimelineGraph for header at index ${headerIndex}`
        );
        return [];
      }
    });
  }

  createTableForVisitor(parsedResponse: Visitor[]) {
    this.headers = [
      'No',
      'Visitor ID',
      'Visitor Name',
      'Contact',
      'Date',
      'Time',
      'Host Name',
      'Purpose',
      'Category',
      'Status',
      'Security',
    ];
    this.columnDefs = this.headers.map((header) => ({
      headerName: header,
      field: header.replaceAll(' ', ''),
      // maxWidth: header === 'No' ? 70 : 135,
      minWidth: 100,
      autoHeight: true,
      editable: false,
      cellClass: 'word-wrap',
    }));

    this.tableData = parsedResponse.flatMap((header, headerIndex) => {
      if (Array.isArray(header.visitorTimelineGraph)) {
        header.visitorTimelineGraph.sort((a, b) => a.index - b.index);

        return header.visitorTimelineGraph.map((data, dataIndex) => ({
          No: `${headerIndex + 1}.${dataIndex + 1}`,
          VisitorID: header.visitorID,
          Status: this.getStatusData(data.status),
          VisitorName: `${header.firstName} ${header.lastName}`,
          Contact: header.phoneNumber,
          Date: new Intl.DateTimeFormat('en-US').format(new Date(data.date)),
          Time: new Intl.DateTimeFormat('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
          }).format(new Date(data.date)),
          HostName: header.hostName,
          Purpose: header.purpose,
          Category: header.visitorCategory,
          Security: (() => {
            switch (header.securityStatus) {
              case 0:
                return 'Unverified';
              case 1:
              case 4:
              case 5:
                return 'Verified';
              default:
                return 'Rejected';
            }
          })(),
        }));
      } else {
        console.warn(
          `No valid visitorTimelineGraph for header at index ${headerIndex}`
        );
        return [];
      }
    });

    // console.log(this.tableData);
  }

  get totalRecords() {
    return this.tableData?.length;
  }

  // Dynamic PDF export function using pdfMake
  exportToPdf() {
    const rows = [];
    const header = this.columnDefs.map((col) => col.headerName);

    // Retrieve all row data (not just rendered rows)
    const allRowData: any[] = [];
    this.gridApi.forEachNode((node: { data: any }) => {
      allRowData.push(node.data);
    });

    // Dynamically calculate column widths based on the maximum text length
    const columnWidths = header.map((_, index) => {
      // let maxLength = 0;
      // allRowData.forEach((row) => {
      //   const cellValue = row[this.columnDefs[index].field] || "";
      //   maxLength = Math.max(maxLength, cellValue.toString().length);
      // });

      // // Adjust width based on max length
      // return maxLength > 10 ? maxLength * 8 : 40; // Adjust multiplier as needed
      return 70;
    });
    // Push the header row
    rows.push(header);

    // Push all the row data
    allRowData.forEach((data) => {
      const row = this.columnDefs.map((col) => data[col.field]);
      rows.push(row);
    });

    // Document definition for the PDF
    const docDefinition: any = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      content: [
        {
          text: `${this.fileName.split('_')[0]} ( ${this.fileName.split('_')[1]
            } - ${this.fileName.split('_')[2]} - ${this.fileName.split('_')[3]
            } )`,
          style: 'header',
        },
        {
          text: `(Generated By: Aumye | Requested By: ${this.loggedUser.fullName})`,
          style: 'sub_header',
        },
        {
          style: 'table',
          table: {
            headerRows: 1,
            // widths: new Array(header.length).fill('*'), // Dynamically adjust widths
            widths: columnWidths, // Dynamically adjust widths
            body: rows,
          },
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          alignment: 'center',
          margin: [0, 0, 0, 10],
        },
        sub_header: {
          fontSize: 14,
          bold: false,
          alignment: 'center',
          margin: [0, 0, 0, 10],
        },
        table: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 12,
          color: 'black',
          alignment: 'center',
          fillColor: '#eeeeee',
        },
        tableData: {
          fontSize: 10,
          alignment: 'center',
          padding: [2, 5],
          lineHeight: 1.2,
          width: 'auto', // Allow text to wrap and adjust the column width automatically
        },
      },
      /* defaultStyle: {
        font: 'Times-Roman',
        fontSize: 10
      }, */
      footer: function (currentPage: string, pageCount: string) {
        return {
          text: 'Page ' + currentPage + ' of ' + pageCount,
          alignment: 'center',
          margin: [0, 10, 0, 0],
        };
      },
    };

    // Create PDF, convert to Blob, and then to Base64
    pdfMake.createPdf(docDefinition).getBlob((blob) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result as string;
        this.createService(base64data, 'pdf');
      };
      reader.readAsDataURL(blob); // Convert Blob to Base64
    });

    // Create PDF and download
    pdfMake.createPdf(docDefinition).download(`${this.fileName}.pdf`);
  }

  extractUserIds(users: UserRegDetails[]): string[] {
    return users.map((user) => user.userId);
  }
  submitRequest() {
    this.dialog.open(this.submittingRequestDialog, {
      disableClose: false,
    });
    const module = this.reportData.get('module')!.value;
    const source = this.reportData.get('source')?.value;
    const startDate = this.reportData.get('startDate')!.value as Date;
    const endDate = this.reportData.get('endDate')!.value as Date;

    // Efficiently set times without mutating
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    const vehicleNumber = this.reportData.get('vehicleNumber')!.value;
    const visitorSearch = this.reportData.get('visitorSearch')!.value;
    if (this.eventEvidence) {
      const data = {
        module: module,
        source: source,
        startDate: startDate,
        endDate: endDate,
        orgId: this.orgId,
        orgName: this.orgName,
        image: this.eventEvidence,
        // emailRecieversIDs: this.reportData.get('assignedRecieversId')!.value,
        emailRecieversIDs: this.extractUserIds(this.selectedUsers),
      };
      let baseServerURL = this.baseServerURL + 'GetReportsData';
      this._http
        .post(baseServerURL, data, {
          responseType: 'text',
        })
        .subscribe((res: any) => {
          if (res === 'Report will be sent on your emial') {
            this.toastr.success(
              'We have started building the report for your face recognition search request. You will receive a status update via email shortly.'
            );
          } else {
            this.toastr.error('Somthing Went Wrong!');
          }
          this.dialog.closeAll();
        });
    } else if (this.isIncident || this.isVisitor) {
      // const module = this.reportData.get('module')!.value;
      // const startDate = this.reportData.get('startDate')!.value as Date;
      // const endDate = this.reportData.get('endDate')!.value as Date;
      const data = {
        module: module,
        source: source,
        startDate: startDate,
        endDate: endDate,
        vehicleNumber: vehicleNumber,
        visitorSearch: visitorSearch,
        orgId: this.loggedUser.organizationID,
      };
      let baseServerURL = this.baseServerURL + 'GetReportsData';
      this._http
        .post(baseServerURL, data, {
          responseType: 'text',
        })
        .subscribe((res: any) => {
          this.dialog.closeAll();
          if (res != null) {
            const parsedResponse = JSON.parse(res);
            if (this.isVisitor) {
              this.createTableForVisitor(parsedResponse);
              this.fileName = `Visitor_${module}_${startDate
                .toISOString()
                .slice(0, 10)
                .split('-')
                .reverse()
                .join('/')}_${endDate
                  .toISOString()
                  .slice(0, 10)
                  .split('-')
                  .reverse()
                  .join('/')}`;
            } else {
              this.createTableForIncident(parsedResponse);
              this.fileName = `Incident_${module}_${startDate
                .toISOString()
                .slice(0, 10)
                .split('-')
                .reverse()
                .join('/')}_${endDate
                  .toISOString()
                  .slice(0, 10)
                  .split('-')
                  .reverse()
                  .join('/')}`;
            }
            this.isReportGenerated = true;
            setTimeout(() => {
              const targetElement = document.querySelector(
                '.collect-reports-section'
              );
              targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }, 250);
          } else {
            this.toastr.success('No Report Data Found');
          }
        });
    } else if (this.isEmployee) {
      let auth_token = localStorage.getItem('AccessToken');
      const httpOptions = {
        headers: new HttpHeaders({
          Authorization: auth_token,
        }),
      };
      let baseServerURL =
        this.baseServerURL +
        'GetEmployees?startDate=' +
        startDate.toDateString() +
        '&endDate=' +
        endDate.toDateString();
      this._http
        .get(baseServerURL, {
          headers: httpOptions.headers,
          responseType: 'text',
        })
        .subscribe({
          next: (res: any) => {
            this.isReportGenerated = true;
            const parsedResponse = JSON.parse(res);
            this.EmployeeDataSource = parsedResponse;
            this.dataSource = {
              startDate: startDate,
              endDate: endDate,
              EmployeeDataSource: parsedResponse,
            };
            this.dialog.closeAll();
            setTimeout(() => {
              const targetElement = document.querySelector(
                '.collect-reports-section'
              );
              targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }, 250);
            this.fileName = `Attendance_${startDate
              .toISOString()
              .slice(0, 10)
              .split('-')
              .reverse()
              .join('/')}_${endDate
                .toISOString()
                .slice(0, 10)
                .split('-')
                .reverse()
                .join('/')}`;
          },
          error: (err: any) => {
            this.dialog.closeAll();
          },
        });
    } else {
    }
  }

  onOptionSelected(val: MatAutocompleteSelectedEvent) {
    // this.createNewVisitorForm.controls.hostUserId.setValue(val.option.value);
  }
  /* onSelectAsset(val: MatSelectChange) {
    this.selectedAssetId = val.value;
  } */
  onSelectAsset(event: any) {
    const selectedAssetName = event.option.value; // Get the selected asset name
    const selectedAsset = this.assets.find(
      (asset) => asset.assetName === selectedAssetName
    );

    if (selectedAsset) {
      this.selectedAssetId = selectedAsset.assetId; // Optionally save the asset ID
    }
  }
  sendEmails() {
    const emailRecieversIDs = this.reportData.get('assignedRecieversId')!.value;
    const module = this.reportData.get('module')!.value;
    const data: any =
      module === 'ANPR' ||
        module === 'FaceRecognition' ||
        module === 'Fire Unverified' ||
        module === 'Fire Verified' ||
        module === 'Fire' ||
        module === 'Intrusion'
        ? this.customIncidentFilteredd
        : this.filteredVisitorDataSource;
    const sendEmailData = {
      emailRecieversIDs: emailRecieversIDs,
      reportsData: data,
      reportType: this.isIncident ? 'Incident' : 'Visitor',
    };
    this.sendReportsToEmail.emit(sendEmailData);
  }
  /* onPrintActivity() {
    const data = {
      visitors: this.customFilteredVisitorDataSource,
      screen: this.screenSize,
    };
    this.dialog.open(PrintableActivityDialogComponent, {
      disableClose: true,
      data,
    });
  } */
  ScreenType = ScreenType;
}
